import { useInfiniteQuery } from "@tanstack/react-query";
import { apiFetch } from "./client";

// Briefing author taxonomy is a strict subset of prime's — briefings have no
// human input and no tools, so only "system" and "agent" ever appear.
export type BriefingAuthor = "system" | "agent";

export interface BriefingStreamItem {
  id: string;
  called_at: string;
  session_id: string | null;
  message_type: string;
  author: BriefingAuthor;
  payload: unknown;
}

export interface BriefingStreamPage {
  items: BriefingStreamItem[];
  nextCursor: string | null;
}

export interface BriefingStreamFilters {
  sessionId?: string;
  since?: string;
  until?: string;
  limit?: number;
}

function buildQuery(filters: BriefingStreamFilters, cursor?: string): string {
  const params = new URLSearchParams();
  if (filters.sessionId) params.set("session_id", filters.sessionId);
  if (filters.since) params.set("since", filters.since);
  if (filters.until) params.set("until", filters.until);
  if (filters.limit) params.set("limit", String(filters.limit));
  if (cursor) params.set("cursor", cursor);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export function useBriefingStream(filters: BriefingStreamFilters) {
  return useInfiniteQuery<BriefingStreamPage>({
    queryKey: ["briefing-stream", filters],
    initialPageParam: undefined,
    queryFn: async ({ pageParam }) =>
      apiFetch<BriefingStreamPage>(
        `/api/dev/briefing-stream${buildQuery(filters, pageParam as string | undefined)}`
      ),
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
}
